export default __webpack_public_path__ + "img/header-27b646ab.png";